<template>
  <div id="app">
      <!-- set progressbar -->
      <vue-progress-bar></vue-progress-bar>
     <transition name="fade">
        <router-view></router-view>
     </transition>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {},
  created(){

  },
}
</script>

<style lang='sass'>
  $black: #9370DB
  $warning: #ffdd57
  $light: #ddd
  $section-padding: 1.5rem 1.5rem
  $modal-z: 200
  $modal-background-background-color: rgba(0, 0, 0, 0.4)
  @import '~bulma/bulma'
  @import '~bulma-badge'
  @import '~bulma-tooltip'
  @import "~vue-swatches/dist/vue-swatches.min.css"
  @import "~vue-multiselect/dist/vue-multiselect.min.css"
</style>
<style lang='scss'>

@font-face { font-family: Pfdintextpro; src: url('./assets/fonts/pfdintextpro-regular.ttf'); }
@font-face { font-family: Pfdintextpro; font-weight: bold; src: url('./assets/fonts/pfdintextpro-bold.ttf'); }
@font-face { font-family: Pfdintextpro;  font-weight: 100; src: url('./assets/fonts/pfdintextpro-thin.ttf'); }


.label.clickable{
    cursor: pointer;
    transition: none;
}

.label.clickable:hover{
    transform: none;
}

.clickable{
    cursor: pointer;
    transition: all .2s ease-in-out;
}

.clickable:hover { transform: scale(1.05); z-index: 100 }

.vue-swatches__trigger{
    border: 1px solid #ccc;
}

html{
    background-color: #f5f5f5;
}
body{
    font-family: 'Pfdintextpro';
}

.fix-footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 5;
    overflow:hidden;
}

.footer{
    background-color: #3D4351;
    color: white !important;
    padding: 0.5rem 0.5rem 0.5rem;
}

.footer a{
    margin: 5px;
    color: white !important;
}

.footer p{
    margin-top: 15px;    
}

.background-sky{
    background-color: #F2F6FA;
}

#app {
    font-family: 'Pfdintextpro';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.box{
    background-color: white;
    margin:5px;
}
.v-toaster .v-toast{
    font-family: 'Pfdintextpro';
}

.iziToast.iziToast-color-green{
    background-color: #00b89c !important;
}

.iziToast.iziToast-color-red{
    background-color: #ff3860 !important;
}

.iziToast.iziToast-color-blue{
    background-color: #3273dc !important;
}

.v-toaster .v-toast.v-toast-error {
  background-color: #ff3860 !important;;
}

.v-toaster .v-toast.v-toast-success {
  background-color: #00b89c !important;
}

.fa-facebook, .fa-facebook-square, .fa-facebook-official {
    color: #3b5998
}

.fa-google-plus, .fa-google-plus-square, .fa-google-plus-official {
    color: #dd4b39
}

.avatar .logo {
  background: #fff;
  height: 75px !important;
  max-height: 150px !important;
}

.fade-fast-enter-active, .fade-fast-leave-active {
  transition-property: opacity;
  transition-duration: .1s;
}

.fade-fast-enter-active {
  transition-delay: .1s;
}

.fade-fast-enter, .fade-fast-leave-active {
  opacity: 0
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.scroll-y{
    overflow-y: auto;
    overflow-x: visible;
    height: 918px;
    padding-left: 30px;
    padding-right: 30px;
}

.card .content, .card .content h4 {
    margin-bottom: 0px;
}

.zero-horizontal-padding{
    padding-left:0px !important;
    padding-right:0px !important;;
}

.zero-vertical-padding{
    padding-top:0px !important;;
    padding-bottom:0px !important;;
}

.zero-vertical-margin{
    margin-top:0px !important;;
    margin-bottom:0px !important;;
}

.minimal-horizontal-padding{
    padding-left:2px !important;
    padding-right:2px !important;;
}

.minimal-vertical-padding{
    padding-top:2px !important;;
    padding-bottom:2px !important;;
}

.minimal-vertical-margin{
    margin-top:2px !important;;
    margin-bottom:2px !important;;
}

.multiline-text{
    word-break: break-word !important;
    white-space: normal  !important;;
    height: auto  !important;;
    max-width: 96%  !important;;
}

.width-fill-available{
    width: -webkit-fill-available;
}


td{
    text-align: center !important;
    vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue